import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    permission: [] // 权限列表
  },
  mutations: {
    SET_PERMISSION (state, permissions) {
      state.permission = permissions
    }
  },
  actions: {
    setPermission ({ commit }, permissions) {
      commit('SET_PERMISSION', permissions)
    }
  }
})
